import React from 'react'
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  InstapaperShareButton,
  LineShareButton,
  LinkedinShareButton,
  LivejournalShareButton,
  MailruShareButton,
  OKShareButton,
  PinterestShareButton,
  PocketShareButton,
  RedditShareButton,
  TelegramShareButton,
  TumblrShareButton,
  TwitterShareButton,
  ViberShareButton,
  VKShareButton,
  WhatsappShareButton,
  WorkplaceShareButton
} from "react-share";
import {
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  InstapaperIcon,
  LineIcon,
  LinkedinIcon,
  LivejournalIcon,
  MailruIcon,
  OKIcon,
  PinterestIcon,
  PocketIcon,
  RedditIcon,
  TelegramIcon,
  TumblrIcon,
  TwitterIcon,
  ViberIcon,
  VKIcon,
  WeiboIcon,
  WhatsappIcon,
  WorkplaceIcon
} from "react-share";
import {useTracking} from "src/shared/virtual_congress/effects/use_tracking";

//visit https://github.com/nygardk/react-share for detailed information
export default function ShareButton(props) {
  const track = useTracking()
  const url = props.url
  const type = props.type
  const trackingSource = props.trackingSource
  var facebookMessengerId = null
  var pinterestImgPath = null
  var additionalInfo = props.info
  if (type === "FacebookMessenger") {
    facebookMessengerId = props.facebookMessengerId
  }
  if (type === "Pinterest") {
    pinterestImgPath = props.media
  }
  var RenderSharedButton = function () {
    switch (type) {
      case "Facebook":
        return (<FacebookShareButton url={url}
                                     beforeOnClick={() => {track(trackingSource, {description: url, identifier: "facebook"}, {event_label: `facebook > ${url}`})}}
                                     quote={additionalInfo?.quote}
                                     hashtag={additionalInfo?.hashtag}>
          <FacebookIcon size={32} round={true}/>
        </FacebookShareButton>)
      case "Whatsapp":
        return (<WhatsappShareButton url={url}
                                     beforeOnClick={() => {track(trackingSource, {description: url, identifier: "whatsapp"}, {event_label: `whatsapp > ${url}`})}}
                                     title={additionalInfo?.title}
                                     image={additionalInfo?.image}>
          <WhatsappIcon size={32} round={true}/>
        </WhatsappShareButton>)
      case "Email":
        return (<EmailShareButton url={url}
                                  beforeOnClick={() => {track(trackingSource, {description: url, identifier: "email"}, {event_label: `email > ${url}`})}}
                                  subject={additionalInfo?.subject}
                                  body={additionalInfo?.body}
                                  separator={additionalInfo?.separator}>
          <EmailIcon size={32} round={true}/>
        </EmailShareButton>)
      case "FacebookMessenger":
        return (<FacebookMessengerShareButton url={url} appId={facebookMessengerId}
                                              beforeOnClick={() => {track(trackingSource, {description: url, identifier: "facebookmessenger"}, {event_label: `facebookmessenger > ${url}`})}}
                                              redirectUri={additionalInfo?.redirectUri}
                                              to={additionalInfo?.to}
        >
          <FacebookMessengerIcon size={32} round={true}/>
        </FacebookMessengerShareButton>)
      case "Instapaper":
        return (<InstapaperShareButton url={url}
                                       beforeOnClick={() => {track(trackingSource, {description: url, identifier: "instapaper"}, {event_label: `instapaper > ${url}`})}}
                                       title={additionalInfo?.title}
                                       description={additionalInfo?.description}
        >
          <InstapaperIcon size={32} round={true}/>
        </InstapaperShareButton>)
      case "Linkedin":
        return (<LinkedinShareButton url={url}
                                     beforeOnClick={() => {track(trackingSource, {description: url, identifier: "linkedin"}, {event_label: `linkedin > ${url}`})}}
                                     title={additionalInfo?.title}
                                     summary={additionalInfo?.summary}
                                     source={additionalInfo?.source}
        >
          <LinkedinIcon size={32} round={true}/>
        </LinkedinShareButton>)
      case "Line":
        return (<LineShareButton url={url}
                                 beforeOnClick={() => {track(trackingSource, {description: url, identifier: "line"}, {event_label: `line > ${url}`})}}
                                 title={additionalInfo?.title}
        >
          <LineIcon size={32} round={true}/>
        </LineShareButton>)
      case "Livejournal":
        return (<LivejournalShareButton url={url}
                                        beforeOnClick={() => {track(trackingSource, {description: url, identifier: "livejournal"}, {event_label: `livejournal > ${url}`})}}
                                        title={additionalInfo?.title}
                                        description={additionalInfo?.description}
        >
          <LivejournalIcon size={32} round={true}/>
        </LivejournalShareButton>)
      case "Mailru":
        return (<MailruShareButton url={url}
                                   beforeOnClick={() => {track(trackingSource, {description: url, identifier: "mailru"}, {event_label: `mailru > ${url}`})}}
                                   title={additionalInfo?.title}
                                   description={additionalInfo?.description}
                                   imageUrl={additionalInfo?.imageUrl}
        >
          <MailruIcon size={32} round={true}/>
        </MailruShareButton>)
      case "Ok":
        return (<OKShareButton url={url}
                               beforeOnClick={() => {track(trackingSource, {description: url, identifier: "ok"}, {event_label: `ok > ${url}`})}}
                               title={additionalInfo?.title}
                               description={additionalInfo?.description}
                               image={additionalInfo?.image}
        >
          <OKIcon size={32} round={true}/>
        </OKShareButton>)
      case "Pinterest":
        return (<PinterestShareButton url={url} media={pinterestImgPath}
                                      beforeOnClick={() => {track(trackingSource, {description: url, identifier: "pinterest"}, {event_label: `pinterest > ${url}`})}}
                                      description={additionalInfo?.description}
        >
          <PinterestIcon size={32} round={true}/>
        </PinterestShareButton>)
      case "Pocket":
        return (<PocketShareButton url={url}
                                   beforeOnClick={() => {track(trackingSource, {description: url, identifier: "pocket"}, {event_label: `pocket > ${url}`})}}
                                   title={additionalInfo?.title}
        >
          <PocketIcon size={32} round={true}/>
        </PocketShareButton>)
      case "Reddit":
        return (<RedditShareButton url={url}
                                   beforeOnClick={() => {track(trackingSource, {description: url, identifier: "reddit"}, {event_label: `reddit > ${url}`})}}
                                   title={additionalInfo?.title}
        >
          <RedditIcon size={32} round={true}/>
        </RedditShareButton>)
      default:
        return null
    }
  }
  return (
    <>
      <RenderSharedButton/>
    </>
  )
}
